import { Ref } from 'vue'

export const countActiveFilters = (values: any[]): number =>
  values
    .filter((value) => value !== undefined && value !== null)
    .map((val) => {
      if (val instanceof Array) {
        return Number(val.length > 0)
      }
      if (val instanceof Object) {
        return Object.values(val).some((v) => v !== undefined && v !== null) ? 1 : 0
      }
      return 1
    })
    .reduce((a, b) => a + b, 0)

export const resetFilters = (filterValues: Ref<Record<string, any>>, filters: string[] = []) => {
  const keys = filters.length > 0 ? filters : Object.keys(filterValues.value)
  for (const key of keys) {
    if (key in filterValues.value) {
      if (filterValues.value[key] instanceof Array) {
        // eslint-disable-next-line no-param-reassign
        filterValues.value[key] = []
      } else if (typeof filterValues.value[key] === 'object') {
        for (const subKey in filterValues.value[key]) {
          if (subKey in filterValues.value[key]) {
            // eslint-disable-next-line no-param-reassign
            filterValues.value[key][subKey] = null
          }
        }
      } else {
        // eslint-disable-next-line no-param-reassign
        filterValues.value[key] = undefined
      }
    }
  }
}
